import { Link, NavLink } from "react-router-dom";
import UseFetch from "../components/UseFetch";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import { fmt } from "../components/const";

const DbAdmin = () => {
    const { data: dashboard, isloading } = UseFetch("dashboard/admin");

    // Tri et calculs
    dashboard?.magasins?.sort((a, b) => b.solde - a.solde);
    const totalSolde = dashboard?.magasins?.reduce((acc, m) => acc + parseFloat(m.solde || 0), 0) || 0;
    const totalDetteInitiale = dashboard?.magasins?.reduce((acc, m) => acc + parseFloat(m.dette_initial?.dette || 0), 0) || 0;
    const totalDetteFacture = dashboard?.magasins?.reduce((acc, m) => acc + parseFloat(m.dette_facture?.dette || 0), 0) || 0;
    const totalDette = totalDetteInitiale + totalDetteFacture || 0;

    // Fonction utilitaire pour formater les nombres
    // Fonction utilitaire pour formater les nombres proprement


    // 📄 Fonction d’exportation PDF
    const exportPDF = () => {
        const doc = new jsPDF("l", "mm", "a4"); // paysage pour plus d’espace

        // 🔹 En-tête
        doc.setFont("helvetica", "bold");
        doc.setFontSize(14);
        doc.text("FANSAN TEXTIL - ADMINISTRATION", 14, 15);
        doc.setFontSize(11);
        doc.text(`Tableau de bord - ${new Date().toLocaleDateString("fr-FR")}`, 14, 22);
        // 🔹 Informations générales
        autoTable(doc, {
            startY: 28,
            head: [["Indicateur", "Valeur"]],
            body: [
                ["Quantité totale en stock", fmt(dashboard?.totalQte)],
                ["Valeur totale du stock", `${fmt(dashboard?.valeur_total)} GNF`],
                ["Conteneurs non approvisionnés", fmt(dashboard?.cont_non_appro?.nb)],
                ["Dette fournisseurs", dashboard?.dette_fourn?.map((d) => `${fmt(d.dette)} ${d.devise}`).join(", ") || "0"],
                ["Dette clients initiales", `${fmt(dashboard?.dette_initiale)} GNF`],
                ["Dette clients factures", `${fmt(dashboard?.dette_facture)} GNF`],
                ["Avance fournisseurs", `${fmt(dashboard?.avance_fourn)} GNF`],
                ["Caisse comptable", `${fmt(dashboard?.caisse)} GNF`],
            ],
            theme: "grid",
            styles: { fontSize: 9 },
            headStyles: { fillColor: [41, 128, 185], textColor: 255 },
        });

        // 🔹 Liste des magasins
        const startY = doc.lastAutoTable.finalY + 10;
        doc.setFontSize(12);
        doc.text("LISTE DES MAGASINS AVEC LEUR SITUATION", 14, startY);

        autoTable(doc, {
            startY: startY + 5,
            head: [
                [
                    "N°",
                    "Magasin",
                    "Téléphone",
                    "Solde actuel (GNF)",
                    "Dette initiale (GNF)",
                    "Dette facture (GNF)",
                    "Total dette (GNF)",
                ],
            ],
            body: dashboard?.magasins?.map((m, i) => [
                i + 1,
                m.magasin?.toUpperCase(),
                m.telephone || "-",
                fmt(m.solde),
                fmt(m.dette_initial?.dette),
                fmt(m.dette_facture?.dette),
                fmt((+m.dette_initial?.dette || 0) + (+m.dette_facture?.dette || 0)),
            ]) || [],
            foot: [
                [
                    { content: "TOTAUX", colSpan: 3, styles: { halign: "center", fontStyle: "bold" } },
                    fmt(totalSolde),
                    fmt(totalDetteInitiale),
                    fmt(totalDetteFacture),
                    fmt(totalDette),
                ],
            ],
            theme: "grid",
            styles: { fontSize: 9, halign: "right" },
            columnStyles: { 1: { halign: "left" } },
            headStyles: { fillColor: [0, 102, 204], textColor: 255 },
            footStyles: { fillColor: [41, 128, 185], textColor: 255 },
        });

        // 🔹 Pied de page (pagination)
        const pageCount = doc.internal.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFontSize(8);
            doc.text(`Page ${i} / ${pageCount}`, doc.internal.pageSize.width - 30, doc.internal.pageSize.height - 10);
        }

        // 💾 Téléchargement
        doc.save(`Dashboard_Admin_${new Date().toISOString().split("T")[0]}.pdf`);
    };

    // ✅ Rendu du tableau de bord
    return isloading ? (
        <div className="loader"></div>
    ) : (
        <div className="dashboard">
            <div className="row mb-2 p-3 rounded justify-content-between bg-white">
                <div className="col-lg-6">
                    <div className="h4 text-primary">FANSAN TEXTIL - ADMINISTRATION</div>
                    <span className="text-secondary fs-5">Tableau de bord</span>
                </div>
                <div className="col-lg-3 text-end">
                    <button onClick={exportPDF} className="btn btn-outline-primary">
                        📄 Exporter PDF
                    </button>
                </div>
            </div>

            <div className="row row-cols-1 row-cols-md-2 row-cols-xl-4">
                <div className="col my-1">
                    <div className="card radius-10 border-start border-0 border-3 border-primary h-100">
                        <div className="py-4 card-body">
                            <div className=" align-items-center">
                                <div>
                                    <p className="mb-0 text-secondary"> Quantite total en stock</p>
                                    <h5 className="my -1 text-primary">{dashboard?.totalQte}</h5>
                                </div>
                                <div className="text-end">
                                    <p className="mb-0 text-secondary fw-bold">Valeur Total</p>
                                    <h5 className="my -1 text-success">{(+dashboard?.valeur_total).toLocaleString()} GNF</h5>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="col my-1">
                    <div className="card radius-10 border-start border-0 border-3 border-warning h-100">
                        <div className="py-4 card-body">
                            <div className=" align-items-center">
                                <div>
                                    <p className="mb-0 text-secondary"> Conteneurs non approvisionnés</p>
                                    <p className="my -1 text-warning">Nombre: {dashboard?.cont_non_appro?.nb || 0}</p>
                                    <p className="my -1 text-warning">Quqntité total: {dashboard?.cont_non_appro?.qte || 0}</p>
                                </div>
                                <div className="text-end">
                                    <p className="mb-0 text-secondary fw-bold">Valeur Total</p>
                                    <h5 className="my -1 text-success">{(+dashboard?.cont_non_appro?.valeur || 0).toLocaleString()} GNF</h5>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="col my-1">
                    <div className="card radius-10 border-start border-0 border-3 border-danger h-100">
                        <div className="py-4 card-body">
                            <div className="d-flex align-items-center">
                                <div>
                                    <p className="mb-0 text-secondary">Dette fournisseurs</p>
                                    {dashboard?.dette_fourn ?
                                        <ul className="text-danger">
                                            {
                                                dashboard?.dette_fourn.map((dette, ind) => (
                                                    <li key={ind}>
                                                        {(+dette.dette)?.toLocaleString()} {dette.devise}</li>
                                                ))
                                            }
                                        </ul> : <div className="text-info">00</div>}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div className="col my-1">
                    <div className="card radius-10 border-start border-0 border-3 border-info h-100">
                        <div className="py-4 card-body">
                            <div className="d-flex align-items-center">
                                <div>
                                    <p className="mb-0 text-secondary">Dette clients</p>
                                    <ul>
                                        <li className="my-1 text-info fs-6">Dettes initiales: {(+dashboard?.dette_initiale)?.toLocaleString()} GNF</li>
                                        <li className="my-2 text-info fs-6">Dettes Factures: {(+dashboard?.dette_facture)?.toLocaleString()} GNF</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col my-1" >
                    <div className="card radius-10 border-start border-0 border-3 border-danger h-100">
                        <div className="py-4 card-body">
                            <div className="d-flex align-items-center">
                                <div>
                                    <p className="mb-0 text-secondary">Total avance fournisseur</p>
                                    <h5 className="my-1  text-danger">{dashboard?.avance_fourn?.toLocaleString()} GNF</h5>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="col my-1" >
                    <div className="card radius-10 border-start border-0 border-3 border-danger h-100">
                        <div className="py-4 card-body">
                            <div className="d-flex align-items-center">
                                <div>
                                    <p className="mb-0 text-secondary">Total depense conteneur</p>
                                    <h5 className="my-1  text-danger">{dashboard?.totalDepenseConteneur?.toLocaleString()} GNF</h5>
                                </div>

                            </div>
                        </div>
                        <Link className="btn btns-m btn-primary mt-auto ms-auto mb-2 me-2 " to={'/depenses'}>Voir details</Link>
                    </div>
                </div>
                <div className="col my-1" >
                    <div className="card radius-10 border-start border-0 border-3 border-success h-100">
                        <div className="py-4 card-body">
                            <div className="d-flex align-items-center">
                                <div>
                                    <p className="mb-0 text-secondary">Caisse comptable</p>
                                    <h5 className="my-1  text-success">{dashboard?.caisse?.toLocaleString()} GNF</h5>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="col my-1">
                    <div className="card h-100 radius-10 border-start border-0 border-3 border-warning bg-warning-subtle">
                        <div className="py-4 card-body">
                            <div className="d-flex align-items-center">
                                <div>
                                    <p className="mb-0 text-warning fs-6 fw-bold">Solde argent confié</p>
                                    <ul>
                                        {
                                            dashboard?.solde_confier?.map((s, ind) =>
                                                <li key={ind}>{`${s.montant.toLocaleString()} ${s.devise}`} </li>
                                            )
                                        }
                                    </ul>
                                </div>
                                <div className="widgets-icons-2 rounded-circle bg-warning text-white p-3 ms-auto"><img src="./images/solde.png" alt="" className="w-100" />
                                </div>
                            </div>
                            <NavLink to='/confier' className="btn btn-primary mt-3 float-end">
                                Detail
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mt-3">
                <h4 className="text-secondary">LISTE DE MAGASINS AVEC LEUR SOLDE ACTUEL</h4>
                <div className="card p-0 border-0">
                    <div className="card-body p-0">
                        <div id="invoice">
                            <div className="table-responsive  invoice  " >
                                <table className="table table-sm table-bordered">
                                    <thead>
                                        <tr className="align-middle">
                                            <th>N°</th>
                                            <th className="text-start fw">MAGASIN</th>
                                            <th className="text-start fw">TELEPHONE</th>
                                            <th className="text-end fw">SOLDE ACTUEL</th>
                                            <th className="  ">
                                                SITUATION DETTE INITIALE
                                                <table className="table">
                                                    <thead>
                                                        <tr className="">
                                                            <td className="small   ">MONTANT</td>
                                                            <td className="small  ">NBRE CLIENT</td>
                                                        </tr>

                                                    </thead>
                                                </table>
                                            </th>
                                            <th className="  border-0 ">
                                                SITUATION DETTE FACTURE
                                                <table className=" ">
                                                    <thead>
                                                        <tr className="table table-bordered">
                                                            <td className="small  table-bordered">MONTANT</td>
                                                            <td className="small  table-bordered">NBRE CLIENT</td>
                                                        </tr>

                                                    </thead>
                                                </table>
                                            </th>
                                            <th className="">TOTAL DETTE</th>
                                        </tr>
                                    </thead>
                                    {dashboard?.magasins ? <tbody>
                                        {dashboard?.magasins?.map((mag, ind) =>
                                            <tr key={ind} className="align-middle">
                                                <td className="no text-center">{ind + 1}</td>
                                                <td className="text-start">{mag.magasin.toUpperCase()}</td>
                                                <td className="text-start">{(+mag.telephone)?.toLocaleString()}</td>
                                                <td className="no text-end">{mag.solde?.toLocaleString()} GNF</td>
                                                <td className="bg-danger-subtle ">
                                                    <table className="table ">
                                                        <tbody>
                                                            <tr>
                                                                <td className="small bg-danger-subtle table-bordered">{parseFloat(mag.dette_initial?.dette || 0).toLocaleString()}</td>
                                                                <td className="small bg-danger-subtle table-bordered">{parseFloat(mag.dette_initial?.nbclient || 0).toLocaleString()}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                </td>
                                                <td className="bg-danger-subtle ">
                                                    <table className="table ">
                                                        <tbody>
                                                            <tr>
                                                                <td className="small bg-danger-subtle table-bordered">{parseFloat(mag.dette_facture?.dette || 0).toLocaleString()}</td>
                                                                <td className="small bg-danger-subtle table-bordered">{parseFloat(mag.dette_facture?.nbclient || 0).toLocaleString()}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>

                                                </td>
                                                <td className="bg-danger-subtle text-end small fw-bold">
                                                    {(parseFloat(mag.dette_facture?.dette || 0) + parseFloat(mag.dette_initial?.dette || 0)).toLocaleString()} GNF
                                                </td>
                                            </tr>
                                        )}
                                        <tr className="fw-bold La session de l’interpréteur de code a expiré">
                                            <td colSpan={3} className="text-center">
                                                TOTAL DES MONTANT
                                            </td>
                                            <td className="no ">
                                                {totalSolde.toLocaleString()} GNF
                                            </td>

                                            <td className="bg-danger-subtle">
                                                {totalDetteInitiale.toLocaleString()} GNF
                                            </td>

                                            <td className="bg-danger-subtle">
                                                {totalDetteFacture.toLocaleString()} GNF
                                            </td>
                                            <td className="bg-danger-subtle">
                                                {(totalDette).toLocaleString()} GNF
                                            </td>
                                        </tr>
                                    </tbody>
                                        : <tr className="text-danger  p-3 text-center bg-danger-subtle">
                                            <td colSpan={5} className="fs-3"> Auncun magasin trouvee</td>
                                        </tr>

                                    }
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DbAdmin;
